// Sucesso significa que print() retornou; o navegador não comprova papel impresso.
export function printReceipt(html, mayPrint = () => true) {
  return new Promise((resolve, reject) => {
    if (typeof html !== "string" || !html.trim()) {
      reject(new Error("Comanda vazia"));
      return;
    }
    const iframe = document.createElement("iframe");
    Object.assign(iframe.style, { position: "fixed", right: "0", bottom: "0", width: "0px", height: "0px", border: "none" });
    const cleanup = () => iframe.remove();
    try {
      document.body.appendChild(iframe);
      iframe.contentDocument.open();
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
    } catch (error) {
      cleanup();
      reject(error);
      return;
    }
    setTimeout(() => {
      try {
        if (!mayPrint()) throw new Error("Impressão substituída por outra versão ou aba");
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        setTimeout(cleanup, 5000);
      }
    }, 500);
  });
}
